import { BlackListType } from '../enums';
export const BLACK_LIST_TYPE = {
    [BlackListType.PAYMENT]: '요금관련',
    [BlackListType.RETURN]: '반납관련',
    [BlackListType.ACCIDENT]: '사고관련',
};
